import { Fade } from 'react-reveal';
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";

import CustomButton from "../../components/CustomButton";
import WorkoutsImageGroup from "../../components/WorkoutsImageGroup";

import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const OnlineWorkout = () => {
  const dispatch = useDispatch();
  const handleTab = () => {
    dispatch(setTabData(CONSTANTS.TABS.ONLINE));
    window.scrollTo(0, 0);
  };
  return (
    <div className="online-workout">
      <Fade left >
        <div className="online-left">
          <WorkoutsImageGroup
            phoneOne={CONSTANTS.phoneOne}
            phoneTwo={CONSTANTS.phoneTwo}
            phoneThree={CONSTANTS.phoneThree}
            phoneFour={CONSTANTS.phoneFour}
            phoneFive={CONSTANTS.phoneFive}
          />
        </div>
      </Fade>
      <Fade right >
        <div className="online-right">
          <div className="title">Online Workouts</div>
          <div className="para">
            With our world-class digital training experience, you get everything you need to get started and stay on
            track. Omni-Active® has helped thousands of users get stronger, healthier, and perform better thanks to
            customized workouts and access to our elite training staff.
        </div>
          <div className="para">
            Workout with instructions for each set, videos to follow along with, and step-by-step instructions.
        </div>

          <div className="para">
            Unlike other fitness apps, these aren’t cookie cutter programs based on fancy algorithms. We prefer doing the
            dirty work ourselves. Our team of elite trainers will build your workouts based on your goals to help you
            reach your fitness goals effectively and efficiently.
        </div>
          <Link to="/programs" onClick={handleTab}>
            <CustomButton type={CONSTANTS.ROUNDED_TYPE}>View Details</CustomButton>
          </Link>
        </div>
      </Fade>
    </div>
  );
};

export default OnlineWorkout;
